import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaPhone, FaEnvelope, FaHome } from 'react-icons/fa';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="container">
      <Helmet>
        <title>Kontakt Oss - HeroPixelLab</title>
        <meta name="description" content="Kontakt HeroPixelLab for spørsmål om produkter, ordre eller samarbeid. Vi svarer raskt!" />
        <link href="https://heropixellab.com/contact/" rel="canonical"/>
      </Helmet>

      <div style={{ padding: '60px 0' }}>
        <h1 style={{ fontSize: '40px', color: '#00e5ff', marginBottom: '30px', textAlign: 'center' }}>Kontakt Oss</h1>

        <div className="contact-info">
          <div className="contact-card">
            <FaPhone className="contact-icon" />
            <h3>Telefon</h3>
            <p>+4738172040</p>
            <p>Man-Fre: 09:00-18:00</p>
          </div>
          <div className="contact-card">
            <FaEnvelope className="contact-icon" />
            <h3>E-post</h3>
            <p>heropixellab@hotmail.com</p>
            <p>Svar innen 24 timer</p>
          </div>
          <div className="contact-card">
            <FaHome className="contact-icon" />
            <h3>Adresse</h3>
            <p>Kirkegata 15, 4611 Kristiansand</p>
            <p>Norge</p>
          </div>
        </div>

        <h2 style={{ fontSize: '28px', color: '#00e5ff', textAlign: 'center', marginBottom: '30px' }}>Send Oss En Melding</h2>

        {submitted ? (
          <div style={{ textAlign: 'center', background: '#1a1225', border: '1px solid #9b59b6', borderRadius: '20px', padding: '40px' }}>
            <h3 style={{ color: '#00e5ff' }}>Takk for din henvendelse!</h3>
            <p style={{ color: '#e0e0e0' }}>Vi har mottatt din melding og vil kontakte deg snart.</p>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Navn</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-post</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Melding</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: '12px', background: '#0a0a0f', border: '1px solid #9b59b6', borderRadius: '8px', color: '#ffffff', minHeight: '120px' }}
              />
            </div>
            <button type="submit" className="submit-button">Send Melding</button>
          </form>
        )}

        <div className="page-number">Side 3</div>
      </div>
    </div>
  );
}

export default Contact;